import { homepageVideos } from '@web-platform/shared-banana-redux/src/state/combinedResults';
import ErrorBoundary from '@web-platform/shared-universal-ui-error-boundary';
import { logWarn } from '@web-platform/shared-universal-utils-frontend/src/helpers/logger';
import { useSelector } from 'react-redux';

import { HomepageVideoCard } from './HomepageVideoCard';

export const HomepageVideoContainer = () => {
  const homepageVideoData = useSelector(homepageVideos);

  if (Object.keys(homepageVideoData).length > 1) {
    logWarn({
      component: 'HomepageVideo',
      message: 'EFS returned more than 1 Homepage Videos.',
      data: JSON.stringify(homepageVideoData),
    });
  }

  const homepageVideo = Object.values(homepageVideoData).pop();
  if (!homepageVideo) {
    return null;
  }

  return (
    <ErrorBoundary
      componentName="HomepageVideoCard"
      fallback={null}
      onError={({ component, error }) =>
        logWarn({
          component,
          error,
          message: 'A data error occurred while rendering the Homepage Video.',
          data: JSON.stringify(homepageVideoData),
        })
      }
    >
      <HomepageVideoCard advert={homepageVideo} />
    </ErrorBoundary>
  );
};
